module.exports = __webpack_public_path__ + "static/media/company.56c0cf8b.svg";